<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-title>Feature Groups</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>

  <div sxRow sxPadding="medium" sxGap="10px">

    <div sxWidth="fill" sxBorderColor="one" sxBorderWidth="1px" sxRadius="medium" sxCol sxPadding="medium" sxGap="10px">
      <div *ngFor="let group of featureGroups" sxBackground="light" sxPadding="medium" sxRadius="medium" sxRow sxDistribution="spaceBetween" sxAlign="center">
        <p>{{group.name}}</p>

        <div sxRow sxGap="10px">
          <super-button height="fit" type="clear" (click)="editFeatureGroup(group)">Edit</super-button>
          <super-button height="fit" type="clear" [action]="delete.bind(this, group._id)" confirmationTitle="Delete?">Delete</super-button>
        </div>

      </div>

    </div>

    <div sxCol sxBackground="light" sxRadius="medium" sxPadding="medium" sxGap="10px">
      <h1>New Feature Group</h1>
      <super-input [(value)]="createFeatureGroupDto.name" (change)="onNameChange()" label="Name"></super-input>
      <super-input [(value)]="createFeatureGroupDto.description" label="description"></super-input>
      <super-button [action]="create">Create</super-button>
    </div>

  </div>

</ion-content>
